import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { userActions } from "./../../_redux/_actions";

import { loginRequest } from "./../../authConfig";

import { useStyles } from "./SignInButton.styles";

/**
 * Renders a button which, when selected, will open a popup for login
 */
const SignInButton = () => {
  const dispatch = useDispatch();
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const classes = useStyles();
  const history = useHistory();

  function handleLogin() {
    // Microsoft login Redirect Page
    instance.loginRedirect(loginRequest).catch(() => {});
  }

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance
        .acquireTokenSilent({
          account: accounts[0],
          scopes: loginRequest.scopes,
        })
        .then((response) => {
          dispatch(
            userActions.corporateLogin({ accessToken: response.accessToken })
          ).then(() => {
            history.push("/dashboard/home");
          });
        });
    }
  }, [inProgress, isAuthenticated, accounts, instance]);

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      className={classes.submit}
      onClick={handleLogin}
    >
      Corporate Login
    </Button>
  );
};

export { SignInButton };
